export const en = {
  'shell.nav.tasks': 'Tasks',
  'shell.nav.tasksToday': 'Today’s tasks',
  'shell.nav.tasksReview': 'Task review',
  'shell.nav.tasksLists': 'Task lists',

  'tasks.today.title': 'Today’s tasks',
  'tasks.today.description': 'What needs doing at your branch today. Tick each item when it is done.',
  'tasks.today.empty': 'Nothing to do today',
  'tasks.today.emptyHint': 'No task list runs at your branch today.',
  'tasks.card.title': 'Today’s tasks',
  'tasks.card.open': 'Open',
  'tasks.progress': '{done} of {total} done',
  'tasks.complete': 'All done',
  'tasks.item.tick': 'Mark done: {item}',
  'tasks.item.untick': 'Mark not done: {item}',
  'tasks.item.doneBy': 'Done by {name} at {time}',
  'tasks.item.notDone': 'Not done',
  'tasks.item.finishedAt': 'Finished at {time}',
  'tasks.note.add': 'Add a note',
  'tasks.note.edit': 'Edit note',
  'tasks.note.label': 'Note',
  'tasks.note.placeholder': 'What should the next shift know?',
  'tasks.note.save': 'Save note',
  'tasks.photo.add': 'Add a picture',
  'tasks.photo.view': 'View picture',
  'tasks.photo.failed': 'The picture could not be saved',
  'tasks.dueAt': 'Due {time}',
  'tasks.anyTime': 'Any time',
  'tasks.forPerson': 'For {name}',
  'tasks.oneOff.badge': 'One-off',

  'tasks.review.title': 'Task review',
  'tasks.review.description': 'What was done at each branch, by whom and when, day by day.',
  'tasks.review.day': 'Day',
  'tasks.review.previous': 'Previous day',
  'tasks.review.next': 'Next day',
  'tasks.review.goToday': 'Today',
  'tasks.review.empty': 'No lists that day',
  'tasks.review.emptyHint': 'No list ran at this branch on that day.',
  'tasks.review.listsComplete': '{done} of {total} lists complete',
  'tasks.review.missed': '{count} not done',
  'tasks.review.history': 'Last two weeks',
  'tasks.review.historyHint': 'Choose a day to see who did what.',
  'tasks.review.col.day': 'Day',
  'tasks.review.col.branch': 'Branch',
  'tasks.review.col.lists': 'Lists',
  'tasks.review.col.done': 'Items done',
  'tasks.review.col.share': 'Share',
  'tasks.review.showDay': 'Show {day}',
  'tasks.review.addTask': 'Add a task',
  'tasks.review.removeTask': 'Remove task',
  'tasks.review.removeTitle': 'Remove this task?',
  'tasks.review.removeHint': 'It disappears from the day. A task someone has already ticked cannot be removed.',
  'tasks.review.removed': 'Task removed',

  'tasks.lists.title': 'Task lists',
  'tasks.lists.description': 'The checklists each branch repeats: opening, closing, cleaning rounds. A fresh copy is made on every day a list runs.',
  'tasks.lists.add': 'Add a list',
  'tasks.lists.empty': 'No lists yet',
  'tasks.lists.emptyHint': 'Add an opening and a closing list so every branch starts and ends the day the same way.',
  'tasks.lists.items.one': '{count} item',
  'tasks.lists.items.other': '{count} items',
  'tasks.lists.everyDay': 'Every day',
  'tasks.lists.paused': 'Paused',
  'tasks.lists.edit': 'Edit {name}',
  'tasks.lists.delete': 'Delete {name}',
  'tasks.lists.deleteTitle': 'Delete this list?',
  'tasks.lists.deleteHint': 'Days already created stay as history. The list stops being created from the next day.',
  'tasks.lists.deleted': 'List deleted',

  'tasks.form.addTitle': 'New list',
  'tasks.form.editTitle': 'Edit list',
  'tasks.form.editHint': 'Changes reach days not yet created. The checklist already made for today stays as it is.',
  'tasks.form.branch': 'Branch',
  'tasks.form.name': 'Name',
  'tasks.form.nameKa': 'Name in Georgian',
  'tasks.form.namePlaceholder': 'Opening',
  'tasks.form.nameRequired': 'Give the list a name.',
  'tasks.form.when': 'When',
  'tasks.form.when.any': 'Any time',
  'tasks.form.when.shift': 'During a shift',
  'tasks.form.when.time': 'At a time of day',
  'tasks.form.shift': 'Shift',
  'tasks.form.shiftRequired': 'Choose the shift.',
  'tasks.form.time': 'Due at',
  'tasks.form.timeRequired': 'Set the time.',
  'tasks.form.days': 'Repeats on',
  'tasks.form.daysHint': 'None chosen means every day.',
  'tasks.form.active': 'Active',
  'tasks.form.activeHint': 'A paused list is not created on new days.',
  'tasks.form.items': 'Items',
  'tasks.form.item': 'Item {number}',
  'tasks.form.itemPlaceholder': 'Switch on the lights',
  'tasks.form.itemKaPlaceholder': 'In Georgian (optional)',
  'tasks.form.addItem': 'Add an item',
  'tasks.form.itemsRequired': 'Add at least one item.',
  'tasks.form.moveUp': 'Move item {number} up',
  'tasks.form.moveDown': 'Move item {number} down',
  'tasks.form.removeItem': 'Remove item {number}',
  'tasks.form.created': 'List added',
  'tasks.form.saved': 'List saved',

  'tasks.oneOff.title': 'Add a task for a day',
  'tasks.oneOff.description': 'A single job for one day, given to a person or to a whole shift.',
  'tasks.oneOff.text': 'What needs doing',
  'tasks.oneOff.textRequired': 'Say what needs doing.',
  'tasks.oneOff.textKa': 'In Georgian',
  'tasks.oneOff.notes': 'Details',
  'tasks.oneOff.branch': 'Branch',
  'tasks.oneOff.date': 'Day',
  'tasks.oneOff.giveTo': 'Give it to',
  'tasks.oneOff.anyone': 'Anyone at the branch',
  'tasks.oneOff.person': 'A person',
  'tasks.oneOff.shift': 'A shift',
  'tasks.oneOff.choosePerson': 'Choose a person',
  'tasks.oneOff.personRequired': 'Choose who it is for.',
  'tasks.oneOff.chooseShift': 'Choose a shift',
  'tasks.oneOff.shiftRequired': 'Choose the shift.',
  'tasks.oneOff.added': 'Task added',

  'admin.apiError.TASK_LIST_EXISTS': 'This branch already has a list with that name.',
  'admin.apiError.TASK_SHIFT_OR_TIME': 'A list belongs to a shift or to a time of day, not both.',
  'admin.apiError.TASK_ITEM_NOT_FOUND': 'One of the items no longer belongs to this list. Reopen the list and try again.',
  'admin.apiError.TASK_DATE_PAST': 'A task is added for today or a later day.',
  'admin.apiError.TASK_ASSIGNEE_OR_SHIFT': 'Give the task to a person or to a shift, not both.',
  'admin.apiError.TASK_ASSIGNEE_NOT_ALLOWED': 'A task can be given only to staff who work at this branch.',
  'admin.apiError.TASK_NOT_ONE_OFF': 'Only a one-off task can be removed.',
  'admin.apiError.TASK_ALREADY_DONE': 'Someone has already ticked this task.',
  'admin.apiError.TASK_DAY_CLOSED': 'That day is closed: an item can be ticked on its own day, or until the day after.',
  'admin.apiError.TASK_ITEM_NOT_DONE': 'Tick the item before adding a picture.',
  'admin.apiError.TASK_BRANCH_NOT_ALLOWED': 'You do not manage tasks at this branch.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.tasks': 'დავალებები',
  'shell.nav.tasksToday': 'დღევანდელი დავალებები',
  'shell.nav.tasksReview': 'დავალებების შემოწმება',
  'shell.nav.tasksLists': 'დავალებების სიები',

  'tasks.today.title': 'დღევანდელი დავალებები',
  'tasks.today.description': 'რა უნდა გაკეთდეს დღეს თქვენს ფილიალში. თითოეული პუნქტი მონიშნეთ, როცა შესრულდება.',
  'tasks.today.empty': 'დღეს დავალებები არ არის',
  'tasks.today.emptyHint': 'თქვენს ფილიალში დღეს არც ერთი სია არ მუშაობს.',
  'tasks.card.title': 'დღევანდელი დავალებები',
  'tasks.card.open': 'გახსნა',
  'tasks.progress': '{total}-დან {done} შესრულებულია',
  'tasks.complete': 'ყველაფერი შესრულებულია',
  'tasks.item.tick': 'შესრულებულად მონიშვნა: {item}',
  'tasks.item.untick': 'შესრულების მოხსნა: {item}',
  'tasks.item.doneBy': 'შეასრულა {name}, {time}-ზე',
  'tasks.item.notDone': 'არ არის შესრულებული',
  'tasks.item.finishedAt': 'დასრულდა {time}-ზე',
  'tasks.note.add': 'შენიშვნის დამატება',
  'tasks.note.edit': 'შენიშვნის შეცვლა',
  'tasks.note.label': 'შენიშვნა',
  'tasks.note.placeholder': 'რა უნდა იცოდეს შემდეგმა ცვლამ?',
  'tasks.note.save': 'შენიშვნის შენახვა',
  'tasks.photo.add': 'სურათის დამატება',
  'tasks.photo.view': 'სურათის ნახვა',
  'tasks.photo.failed': 'სურათის შენახვა ვერ მოხერხდა',
  'tasks.dueAt': 'ვადა: {time}',
  'tasks.anyTime': 'ნებისმიერ დროს',
  'tasks.forPerson': 'ვისთვის: {name}',
  'tasks.oneOff.badge': 'ერთჯერადი',

  'tasks.review.title': 'დავალებების შემოწმება',
  'tasks.review.description': 'რა გაკეთდა თითოეულ ფილიალში, ვინ და როდის გააკეთა — დღეების მიხედვით.',
  'tasks.review.day': 'დღე',
  'tasks.review.previous': 'წინა დღე',
  'tasks.review.next': 'მომდევნო დღე',
  'tasks.review.goToday': 'დღეს',
  'tasks.review.empty': 'იმ დღეს სიები არ ყოფილა',
  'tasks.review.emptyHint': 'ამ ფილიალში იმ დღეს არც ერთი სია არ მუშაობდა.',
  'tasks.review.listsComplete': '{total} სიიდან სრულად შესრულებულია {done}',
  'tasks.review.missed': 'შეუსრულებელია: {count}',
  'tasks.review.history': 'ბოლო ორი კვირა',
  'tasks.review.historyHint': 'აირჩიეთ დღე, რომ ნახოთ ვინ რა გააკეთა.',
  'tasks.review.col.day': 'დღე',
  'tasks.review.col.branch': 'ფილიალი',
  'tasks.review.col.lists': 'სიები',
  'tasks.review.col.done': 'შესრულებული პუნქტები',
  'tasks.review.col.share': 'წილი',
  'tasks.review.showDay': 'ჩვენება: {day}',
  'tasks.review.addTask': 'დავალების დამატება',
  'tasks.review.removeTask': 'დავალების წაშლა',
  'tasks.review.removeTitle': 'წაიშალოს ეს დავალება?',
  'tasks.review.removeHint': 'ის დღიდან გაქრება. დავალება, რომელიც უკვე მონიშნულია, ვერ წაიშლება.',
  'tasks.review.removed': 'დავალება წაშლილია',

  'tasks.lists.title': 'დავალებების სიები',
  'tasks.lists.description': 'ჩამონათვალები, რომლებსაც თითოეული ფილიალი იმეორებს: გახსნა, დახურვა, დასუფთავების ტურები. სიის თითოეულ სამუშაო დღეს იქმნება ახალი ასლი.',
  'tasks.lists.add': 'სიის დამატება',
  'tasks.lists.empty': 'სიები ჯერ არ არის',
  'tasks.lists.emptyHint': 'დაამატეთ გახსნისა და დახურვის სია, რომ ყველა ფილიალი დღეს ერთნაირად იწყებდეს და ამთავრებდეს.',
  'tasks.lists.items.one': '{count} პუნქტი',
  'tasks.lists.items.other': '{count} პუნქტი',
  'tasks.lists.everyDay': 'ყოველდღე',
  'tasks.lists.paused': 'შეჩერებულია',
  'tasks.lists.edit': 'შეცვლა: {name}',
  'tasks.lists.delete': 'წაშლა: {name}',
  'tasks.lists.deleteTitle': 'წაიშალოს ეს სია?',
  'tasks.lists.deleteHint': 'უკვე შექმნილი დღეები ისტორიად რჩება. სია მომდევნო დღიდან აღარ შეიქმნება.',
  'tasks.lists.deleted': 'სია წაშლილია',

  'tasks.form.addTitle': 'ახალი სია',
  'tasks.form.editTitle': 'სიის შეცვლა',
  'tasks.form.editHint': 'ცვლილებები ეხება ჯერ შეუქმნელ დღეებს. დღევანდელი უკვე შექმნილი სია უცვლელი რჩება.',
  'tasks.form.branch': 'ფილიალი',
  'tasks.form.name': 'სახელი',
  'tasks.form.nameKa': 'სახელი ქართულად',
  'tasks.form.namePlaceholder': 'გახსნა',
  'tasks.form.nameRequired': 'მიუთითეთ სიის სახელი.',
  'tasks.form.when': 'როდის',
  'tasks.form.when.any': 'ნებისმიერ დროს',
  'tasks.form.when.shift': 'ცვლის დროს',
  'tasks.form.when.time': 'დღის კონკრეტულ საათზე',
  'tasks.form.shift': 'ცვლა',
  'tasks.form.shiftRequired': 'აირჩიეთ ცვლა.',
  'tasks.form.time': 'ვადა',
  'tasks.form.timeRequired': 'მიუთითეთ დრო.',
  'tasks.form.days': 'მეორდება',
  'tasks.form.daysHint': 'თუ არცერთი არ არის არჩეული, ყოველდღე მეორდება.',
  'tasks.form.active': 'აქტიურია',
  'tasks.form.activeHint': 'შეჩერებული სია ახალ დღეებზე აღარ იქმნება.',
  'tasks.form.items': 'პუნქტები',
  'tasks.form.item': 'პუნქტი {number}',
  'tasks.form.itemPlaceholder': 'ჩართეთ განათება',
  'tasks.form.itemKaPlaceholder': 'ქართულად (არასავალდებულო)',
  'tasks.form.addItem': 'პუნქტის დამატება',
  'tasks.form.itemsRequired': 'დაამატეთ მინიმუმ ერთი პუნქტი.',
  'tasks.form.moveUp': 'პუნქტი {number} ზემოთ',
  'tasks.form.moveDown': 'პუნქტი {number} ქვემოთ',
  'tasks.form.removeItem': 'პუნქტი {number}-ის წაშლა',
  'tasks.form.created': 'სია დამატებულია',
  'tasks.form.saved': 'სია შენახულია',

  'tasks.oneOff.title': 'ერთდღიანი დავალების დამატება',
  'tasks.oneOff.description': 'ერთი სამუშაო ერთი დღისთვის — კონკრეტულ ადამიანს ან მთელ ცვლას.',
  'tasks.oneOff.text': 'რა უნდა გაკეთდეს',
  'tasks.oneOff.textRequired': 'მიუთითეთ, რა უნდა გაკეთდეს.',
  'tasks.oneOff.textKa': 'ქართულად',
  'tasks.oneOff.notes': 'დეტალები',
  'tasks.oneOff.branch': 'ფილიალი',
  'tasks.oneOff.date': 'დღე',
  'tasks.oneOff.giveTo': 'ვის მიენიჭოს',
  'tasks.oneOff.anyone': 'ფილიალის ნებისმიერ თანამშრომელს',
  'tasks.oneOff.person': 'კონკრეტულ ადამიანს',
  'tasks.oneOff.shift': 'ცვლას',
  'tasks.oneOff.choosePerson': 'აირჩიეთ ადამიანი',
  'tasks.oneOff.personRequired': 'აირჩიეთ, ვისთვისაა.',
  'tasks.oneOff.chooseShift': 'აირჩიეთ ცვლა',
  'tasks.oneOff.shiftRequired': 'აირჩიეთ ცვლა.',
  'tasks.oneOff.added': 'დავალება დამატებულია',

  'admin.apiError.TASK_LIST_EXISTS': 'ამ ფილიალში ამ სახელის სია უკვე არსებობს.',
  'admin.apiError.TASK_SHIFT_OR_TIME': 'სია მიბმულია ან ცვლაზე, ან დღის კონკრეტულ საათზე — ორივეზე ერთად ვერ იქნება.',
  'admin.apiError.TASK_ITEM_NOT_FOUND': 'ერთ-ერთი პუნქტი აღარ ეკუთვნის ამ სიას. ხელახლა გახსენით სია და სცადეთ თავიდან.',
  'admin.apiError.TASK_DATE_PAST': 'დავალება ემატება დღევანდელი ან უფრო გვიანი დღისთვის.',
  'admin.apiError.TASK_ASSIGNEE_OR_SHIFT': 'დავალება მიანიჭეთ ან ადამიანს, ან ცვლას — ორივეს ერთად არა.',
  'admin.apiError.TASK_ASSIGNEE_NOT_ALLOWED': 'დავალება შეიძლება მიენიჭოს მხოლოდ ამ ფილიალში მომუშავე თანამშრომელს.',
  'admin.apiError.TASK_NOT_ONE_OFF': 'წაშლა შესაძლებელია მხოლოდ ერთჯერადი დავალების.',
  'admin.apiError.TASK_ALREADY_DONE': 'ეს დავალება უკვე მონიშნულია.',
  'admin.apiError.TASK_DAY_CLOSED': 'ეს დღე დახურულია: პუნქტის მონიშვნა შეიძლება მის დღეს ან მომდევნო დღის განმავლობაში.',
  'admin.apiError.TASK_ITEM_NOT_DONE': 'სურათის დამატებამდე მონიშნეთ პუნქტი.',
  'admin.apiError.TASK_BRANCH_NOT_ALLOWED': 'ამ ფილიალში დავალებებს ვერ მართავთ.',
};
